var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-upload", class: { inline: _vm.inline } },
    [
      _vm.showUpload
        ? _c(
            "div",
            { staticClass: "uploads" },
            [
              _vm.direction == "positive" ? _vm._t("content") : _vm._e(),
              _vm._v(" "),
              _c(
                "el-upload",
                {
                  attrs: {
                    disabled: _vm.disabled,
                    name: "file",
                    "list-type": "file",
                    "show-file-list": false,
                    action: _vm.action,
                    headers: _vm.headers,
                    accept: _vm.accept,
                    multiple: _vm.multiple,
                    limit: _vm.limit,
                    "on-exceed": _vm.handleExceed,
                    "file-list": _vm.fileList,
                    data: _vm.parameter,
                    "before-upload": _vm.uploadBefore,
                    "on-progress": _vm.uploadProgress,
                    "on-success": _vm.handleSuccess,
                    "on-error": _vm.uploadError
                  }
                },
                [_vm._t("upload")],
                2
              ),
              _vm._v(" "),
              _vm.direction == "reverse" ? _vm._t("content") : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showList
        ? _c(
            "ul",
            { staticClass: "file-list" },
            _vm._l(_vm.dataList, function(item, index) {
              return _c(
                "li",
                { key: item.uid },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm._f("fileView")(item.filePath || item.fileUrl),
                        target: "_blank",
                        title: item.fileName
                      }
                    },
                    [_vm._v(_vm._s(item.fileName))]
                  ),
                  _vm._v(" "),
                  !_vm.disabled
                    ? _c("div", { staticClass: "right" }, [
                        _c("i", {
                          staticClass: "el-icon-delete",
                          on: {
                            click: function($event) {
                              return _vm.removeFile(index)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.status == "success"
                    ? _c("span", {
                        staticClass: "el-icon-check status-icon success"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.status == "uploading" || item.status == "ready"
                    ? _c("span", {
                        staticClass: "el-icon-loading status-icon loading"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.status == "uploading" || item.status == "ready"
                    ? _c("el-progress", {
                        attrs: {
                          "stroke-width": 2,
                          "text-inside": true,
                          "show-text": false,
                          color: "#35BBBD",
                          percentage: item.percentage
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-266f3366", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-266f3366","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileUpload.vue
// module id = 534
// module chunks = 14